"use strict";
/// <reference path="irep.js"/>

IREP.toolsUpdate = (function () {
    var _tagAnimationSpeed = 500;
    var defaultSearchValue = "";

    var initRepeater = function () {
        $(".dvToolItem").hover(
            function () {
                $(this).find(".HoverTextHolder").show().css("display", "table");
            },
            function () {
                $(this).find(".HoverTextHolder").hide();
            }
        );

        positionPager(); //Set initial pager position.

        $(".dvToolItem").on('click', function () {
            //Scrape Data
            scrapeAndDisplayData($(this));
            showDrawer($(this));
        });



        $("#NextArrow").click(function () {
            $("a[rel='next']").click(); //Simulate pager click.
            return false;
        });
        
        NextArrow();

        var toolid = getToolId(window.location.href);
        if (toolid !== undefined && toolid !== null) {
            var ctrl = $('.dvToolItem[data-id=' + toolid + ']');
            scrapeAndDisplayData(ctrl);
            showDrawer(ctrl);
        }
    };

    var getToolId = function (url) {
        if (url.toLowerCase().indexOf("toolid") == -1) return null;

        var sub1 = url.substring(url.toLowerCase().indexOf("toolid"));
        if (sub1.indexOf("&") != -1) {
            sub1 = sub1.substring(0, sub1.indexOf("&"));
        }
        var splitme = sub1.split("=");
        return splitme[1];
    };
    
    // Determine display rules for the next arrow on the results. Don't show it if we line up perfectly with the # of displayed results, or if there's no more items. 
    var NextArrow = function () {
        var ctrl = $("#NextArrow");
        var count = $(".dvToolItem").length;
        var eachRow = Math.floor($("#dvToolsRepeaterResults").width() / 204);
        var remainder = count % eachRow;
        if (remainder > 0 && typeof $("a[rel='next']").attr("href") !== "undefined" && $("a[rel='next']").attr("href").indexOf("void") == -1) {
            ctrl.css("display", "inline-block");
        } else {
            ctrl.css("display", "none");
        }
    };

    var resizeDebounce = function () {
        NextArrow();
        positionPager(); 
    };

    var positionPager = function () {
        //This code dynamically places the pager to the direct north of the last search item in the first row. 
        //       This could easily be compressed into one command, but I think the logic here is complicated enough that it deserves to be broken
        //       out for legibility and reusability. 

        if ($(".dvToolItem")[0] == undefined) return;  //Check if we have repeater items. 

        //First: Get the spacing between each item, and then the amount of padding between each item. We need the padding so that the end of the pager
        //       aligns with the end of the last item, not the end plus the padding. 
        var spacing = $(".dvToolItem").next().position().left - $(".dvToolItem").first().position().left;
        var padding = spacing - $(".dvToolItem").width();

        //Second: Now get the number of items that are displayed horizontally across the page. 
        var numItems = Math.floor($("#dvToolsRepeaterResults").width() / spacing);

        //Finally: Calculate the positioning of the item.
        var leftPos = (spacing * numItems) - padding - $("#dvTxtSearchPager").outerWidth();

        //We have our calculation complete. Set the position of the pager.
        $("#dvTxtSearchPager").css('left', leftPos);
    };

    var showSelection = function (options) {
        if (options.searchType === "1") {
            toggleFeatured($("#dvToolsFeatured"));
        }
        if (options.catFilter !== '' && options.catFilter !== undefined) {
            toggleCategory($("#Category" + options.catFilter));
        }
        if (options.typeFilter !== '' && options.typeFilter !== undefined) {
            toggleFilter($("#Category" + options.typeFilter));
        }
        if (options.searchText !== undefined) {
            $("#txtSearchVal").val(options.searchText);
        }
    };

    var init = function (toolsOptions) {
        showSelection(toolsOptions);
        initCommentTriggers();

        var isActive = "survey-Panel",
        img_src = "",
        new_src = "";
        $(".mouseover").hover(function () {
            img_src = $(this).attr('src');
            new_src = $(this).attr('rel');
            $(this).attr('src', new_src);
            $(this).attr('rel', img_src);
        },
       function () {
           $(this).attr('src', img_src);
           $(this).attr('rel', new_src);
       });

        var cache = new Array();
        $(".mouseover").each(function () {
            var cacheImage = document.createElement('img');
            cacheImage.src = $(this).attr('rel');
            cache.push(cacheImage);
        });

        //Turn off Survey, Quotes -- Supposed to default to survey if not taken
        $(".quotes-Panel").hide();
        $(".survey-Panel").hide();
        $(".detail-Panel").show();
        $(".close-Panel").on('click', function () {
            closeModal();
        });

        $("#toolDownload").click(function () {

            postToolLog($("#toolDownload").attr('data-ToolId'));

            if ($("#toolDownload").attr("data-type") == 'Video') {
                var dataUrl = $("#toolDownload").attr('href');
                $(".DetailVideoPlayer").show();
                $(".DetailVideoPlayer").height($(document).height());

                var type = "";
                
                if (dataUrl.match(/flv$/)) {
                    type="video/flv"; 
                }
                else if (dataUrl.match(/mp4$/)) {
                    type = "video/mp4";
                }

                //We're rendering the player each time we initialize the video viewer. 
                //Without a unique name, the browser won't properly render the second instance of the player. 
                var idName = 'videoTool_' + Math.floor((1 + Math.random()) * 0x10000).toString(16);
                $("#vidContainer").html("<video id='" + idName + "' class='video-js vjs-default-skin' autoplay='autoplay' controls preload='none' width='640' height='480' data-setup='{}'><source src='" + dataUrl + "' type='" + type + "' data-videoUID='" +  $("#toolDownload").attr('data-uid') + "' /> </video>");

                videojs(idName).ready (function () { 
                    var myPlayer = this;
                    myPlayer.load();
                    if (type == "video/mp4"){
                        IREP.VideoTracking.init(idName + "_html5_api");
                    }
                    //myPlayer.play(); //Autoplay causes IE11 to retain the 'play' button overtop of the video. Removing autoplay seems like an easy enough fix. Lets see if anyone notices.
                });
                return false;
            }
        });


        $(window).resizeDebounce({
            onResizeEnd: resizeDebounce,
            runOnStart: false,
            timeoutDelay: 100
        });

        $(document).keyup(function (e) {
            if (e.which === 27) { //Pressing escape should close overlays. But not all the overlays at once. 
                if ($(".DetailVideoPlayer").is(":visible")) {
                    $(".DetailVideoPlayer").hide();
                }
                else {
                    closeModal();
                }
            }
        });

        $("#btnCloseOverlay").on("click", function () {
            stopPlayer(); 
        });

        $("#vidOverlayBackground").on("click", function () {
            stopPlayer();
        });

        $(".ModalView").click(function () {
            closeModal();
        });

        $(".detailInfo").click(function () {
            isActive = "detail-Panel";
            $(".detail-Panel").fadeIn(800, function () { });
            $(".close-Panel").fadeIn(800, function () { });
            $(".quotes-Panel").hide();
            $(".survey-Panel").hide();
            $(".tagging-Panel").hide();
        });

        $(".detailComments")
            .click(function () {
                isActive = "quotes-Panel";
                $(".quotes-Panel").fadeIn(800, function () { });
                $(".close-Panel").fadeIn(800, function () { });
                $(".detail-Panel").hide();
                $(".survey-Panel").hide();
                $(".tagging-Panel").hide();
            });


        $(".detail-Tags")
           .click(function () {
               isActive = "tagging-Panel";
               $(".tagging-Panel").fadeIn(800, function () { });
               $(".close-Panel").fadeIn(800, function () { });
               $(".detail-Panel").hide();
               $(".survey-Panel").hide();
               $(".quotes-Panel").hide();
           });

        $(".detail-Survey").click(function (e) {
            isActive = "survey-Panel";
            $(".survey-Panel").fadeIn(800, function () { });
            $(".close-Panel").fadeIn(800, function () { });
            $(".quotes-Panel").hide();
            $(".detail-Panel").hide();
            $(".tagging-Panel").hide();

            // Training should not display anyway
            if ($(".toolsDetailContainer").find('.surveyContainer').html() == "") {
                $.ajax({
                    type: "post",
                    contenttype: "application/json; charset=utf-8",
                    url: "Learning/activitysurvey.ajax?toolsId=" + $("#toolDownload").attr("data-ToolId"),
                    success: function (html) {
                        $(".toolsDetailContainer").find('.surveyContainer').html(html);
                    },
                    error: function (xhr, textstatus, errorthrown) {
                    }
                    //}
                });
            }
            e.stopPropagation();
        });
        defaultSearchValue = $("#txtSearchVal").attr("defaultText");

        $("#dvToolsFeatured").on("click", function () {
            $(".dvApplyClearFeatured").css("display", "none");
            toggleFeatured($(this));
            loadResults($("#txtSearchVal"), $("#selToolsOption"));
        });

        $("#toolsCategoriesControl .ToolsCategory").on("click", function () {
            $(".dvApplyClearCat").css("display", "none");
            toggleCategory($(this));
            loadResults($("#txtSearchVal"), $("#selToolsOption"));
        });

        $("#toolsFilterControls .ToolsCategory").on("click", function () {
            $(".dvApplyClearType").css("display", "none");
            toggleFilter($(this));
            loadResults($("#txtSearchVal"), $("#selToolsOption"));
        });

        $("#btnSearchTools").on("click", function () {
            loadResults($("#txtSearchVal"), $("#selToolsOption"));
        });

        $("#dvToolsRepeaterContainer").on('pjax:start', function () {
            $("#LoadingOverlay").fadeIn("fast");
            $("#dvToolsRepeaterContainer").fadeTo("fast", 0.08);
            $("#topPagerHolder").fadeTo("fast", 0.08);
        });
        $("#dvToolsRepeaterContainer").on("pjax:timeout", function () { return false; });

        /* When a pjax call finishes, hide the loader and then reset the footer position; Sometimes we only get one or two items
           back, so it doesn't fit a full screen. Other times, it needs to expand the screen size. */
        $("#dvToolsRepeaterContainer").on('pjax:end', function () {
            $("#LoadingOverlay").fadeOut();
            IREP.master.setFooterPosition();
            $("#dvToolsRepeaterContainer").fadeTo("fast", 1);
        });

        // event handler for reload results.
        $("#dvToolsRepeaterResults").on('loadResults', function (event, catFilter, typeFilter, pageNum) {
            if (catFilter) {
                $("#catFilter").val($.trim(catFilter));
            }

            if (typeFilter) {
                $("#typeFilter").val($.trim(typeFilter));
            }

            if (pageNum) {
                $("#page").val(pageNum);
            }

            loadResults($("#txtSearchVal"), $("#selToolsOption"));
        });

        // clicking the search button
        $("#learningSearch").click(function () {
            $(this).trigger('loadResults', [null, null, 1]);
        });

        // Enter keypress should trigger the loadresults
        $("#dvTxtSearch").keypress(function (e) {
            if (e.which == 13) {
                loadResults($("#txtSearchVal"), $("#selToolsOption"));
                e.preventDefault();
            }
        });

    };

    var stopPlayer = function () {
        $(".DetailVideoPlayer").hide();
        if ($("#vidContainer video")[0] != undefined) { //If it's a standard video player
            videojs($("#vidContainer video")[0].id).dispose(); //cleanup - remove element. 
        }
        else if ($("#vidContainer object")[0] != undefined != undefined) { //Check if it's an FLV player
            videojs($("#vidContainer object")[0].id).dispose(); //cleanup - remove element. 
        }
    };

    var initCommentTriggers = function () {
        $(".addComment").click(function () {
            $.ajax({
                type: "POST",
                contentType: "application/x-www-form-urlencoded; charset=utf-8",
                url: "Learning/ActivityCommentsList.ajax?AddToolsComment=",
                data: { toolsId: $("#toolDownload").attr("data-ToolId"), commentText: $(".toolsDetailContainer").find('#txtComment').val(), commentID: $(".toolsDetailContainer").find('#txtCommentId').val() },
                success: function (msg) {
                    $(".toolsDetailContainer").find('.commentsContainer').html(msg);
                    $(".toolsDetailContainer").find(".commentsContainer").mCustomScrollbar({ theme: 'dark-thick', scrollButtons: { enable: true } });
                    if ($(".toolsDetailContainer").find('#txtCommentId').val() == "") {
                        $(".toolsDetailContainer").find(".commentsContainer").mCustomScrollbar("scrollTo", "bottom");
                    } else {
                        $(".toolsDetailContainer").find(".commentsContainer").mCustomScrollbar("scrollTo", ".commentId-" + $(".toolsDetailContainer").find('#txtCommentId').val());
                    }
                    $(".toolsDetailContainer").find('#txtComment').val("");
                    $(".toolsDetailContainer").find('#txtCommentId').val("");
                },
                error: function (xhr, textStatus, errorThrown) {
                }
            });
        });


        $(document).on("keypress", ".submitComment", function (event) {
            if (event.which == "13") {
                $(".addComment", this).click();
                return false;
            }
        });
    }

    /*
    * Log download of tool to DB for reporting. 
    */
    var postToolLog = function (toolId) {
        var params = { toolId: toolId };
        IREP.callApi("tools/logDownload", "POST", params);
    };

    var scrapeAndDisplayData = function (activeSelector) {
        var dataUrl = $(activeSelector).attr('data-url');
        var dataPublishdate = $(activeSelector).attr('data-publishdate');
        var dataImgUrl = $(activeSelector).attr('data-imgurl');
        var dataDesc = $(activeSelector).attr('data-desc');
        var dataId = $(activeSelector).attr('data-Id');
        var dataType = $(activeSelector).attr('data-displaytype');
        var filter = $(activeSelector).attr('data-filters');
        var filterCollectionId = $(activeSelector).attr('data-filtercollectionid');
        var dvTitleText = $(activeSelector).find(".dvTitleText").text();
        var hoverText = $(activeSelector).find(".HoverText").text();
        var hoverTextTrim = $.trim(hoverText);
        var dataIsNew = $(activeSelector).find(".newTool").text();
        var NewTrim = $.trim(dataIsNew);

        if (NewTrim === "New") {
            $(".newtraining").show();
        } else {
            $(".newtraining").hide();
        }
        $(".toolDescription").html(dataDesc);
        $(".published").text(dataPublishdate);
        $("#toolsImage").attr('src', dataImgUrl);
        $("#toolDownload").attr('href', dataUrl);
        $(".detailToolsTitle").text(dvTitleText);
        $(".contentType").html(dataType);
        if (getParameterByName("useNewTagging") != "") {
            $(".tags").html(filter).show();
            $(".tagLabel").show();
        } else {
            $(".tagLabel").hide();
            $(".tags").hide()
        }

        if (dataUrl.match(/flv$/) || dataUrl.match(/mp4$/)) /* Tag videos so that we know to show the player not download the file */ {
            $("#toolDownload").attr('data-type', "Video");
            $("#toolDownload").attr('data-uid', $(activeSelector).attr('data-uid'));
        }
        else {
            $("#toolDownload").attr('data-type', "Download");
        }

        $(".tray-HoverText").text(hoverText);

        $("#toolDownload").attr('data-ToolId', dataId);

        if ($(activeSelector).attr('data-surveytaken').toLowerCase() == "true") {
            $(".detail-Survey").hide();
        }
        else {
            $(".detail-Survey").show();
        }

        if (filterCollectionId == 0) {
            IREP.callApi("Filters/NewFilterCollection",
                  "POST",
                  {
                      filterType: 'tools',
                      id: dataId
                  }).done(function (data) {
                      if (data !== null) {

                          var url = IREP.generateSiteLink("/editor/filters/" + data.filterCollectionId);
                          $(".dvToolItem[data-id=" + dataId + "]").attr('data-filtercollectionid', data.filterCollectionId);
                          $("#newTaggingWrapper").load(url);
                      }
                  });
        } else {
            var url = IREP.generateSiteLink("/editor/filters/" + filterCollectionId);

            $("#newTaggingWrapper").load(url);
        }

        loadComments();
    }

    var loadComments = function () {
        $.ajax({
            type: "POST",
            contentType: "application/json; charset=utf-8",
            url: "Learning/ActivityCommentsList.ajax?toolsId=" + $("#toolDownload").attr('data-ToolId'),
            success: function (msg) {
                $(".toolsDetailContainer").find('.commentsContainer').html(msg);
            },
            error: function (xhr, textStatus, errorThrown) {
            }
        });
    }

    var showDrawer = function (ctrl) {
        // var detailDiv = $("div.DetailView[actcode='" + ctrl.attr("actcode") + "']").first();
        var borderWrapper = ctrl.find("*").addBack().filter(".borderWrapper");

        /* Hide video player if visible */
        $("#searchResults").show();
        $(".detailInfo").click(); //Force initial display to be the details of the tool
        $(".surveyContainer").html(""); //Remove the survey container's contents, so that it'll reload when you click it again. 

        var tl = new TimelineMax();
        if (ctrl.attr("ClickedImageTitle") == 'true') {
            tl.insert(TweenMax.to(borderWrapper, .1, { css: { border: "5px solid white", marginLeft: "0px", marginTop: "0px", marginRight: "0px", marginBottom: "0px" } }), 0);
            tl.insert(TweenMax.to($(".toolsDetailContainer"), .4, { height: 0, autoAlpha: 0, display: 'none' }), 0);
            tl.insert(TweenMax.to($(".ModalView"), .4, { display: 'none', autoAlpha: 0 }), 0);
            ctrl.attr("ClickedImageTitle", "false");
            ctrl.css("z-index", 0);
            $("#scrollSpacer").css("height", "0px");
        } else {
            ctrl.css("z-index", 91);
            tl.insert(TweenMax.to($(".ModalView"), .4, { autoAlpha: 0.4, display: 'block' }), 0);
            tl.insert(TweenMax.to(borderWrapper, .1, { css: { border: "10px solid #0071c5", marginLeft: "-5px", marginTop: "-5px", marginRight: "-5px", marginBottom: "-5px" } }), 0);
            tl.insert(TweenMax.to($(".toolsDetailContainer"), .4, { height: "446px", autoAlpha: 1, display: 'block', onComplete: scrollItemToDrawer, onCompleteParams: [ctrl] }), 0);

            ctrl.attr("ClickedImageTitle", "true");
        }
        tl.play();
    }
    var scrollItemToDrawer = function (ctrl) {
        var ControlToUse = ctrl.find("*").addBack().filter(".borderWrapper");
        if (ControlToUse.offset().top + ControlToUse.outerHeight() < $(".toolsDetailContainer").offset().top) {
            $("html,body").animate({ scrollTop: $(window).scrollTop() - ($(".toolsDetailContainer").offset().top - ControlToUse.offset().top - ControlToUse.outerHeight()) }, 'fast');
        }
        else {
            $("#scrollSpacer").css("height", (ControlToUse.offset().top + ControlToUse.outerHeight()) - $(".toolsDetailContainer").offset().top + 150);
            $("html,body").animate({ scrollTop: $(window).scrollTop() + (ControlToUse.offset().top + ControlToUse.outerHeight() - $(".toolsDetailContainer").offset().top) }, 'fast');
        }
    }

    var closeModal = function () {
        var tl = new TimelineMax();
        $(".detailActivityCommentsWrapper").slideUp();
        tl.insert(TweenMax.to($(".borderWrapper"), .1, { css: { border: "5px solid white", marginLeft: "0px", marginTop: "0px", marginRight: "0px", marginBottom: "0px" } }), 0);
        tl.insert(TweenMax.to($(".toolsDetailContainer"), .4, { height: 0, autoAlpha: 0, display: 'none' }), 0);
        tl.insert(TweenMax.to($(".ModalView"), .4, { display: 'none', autoAlpha: 0 }), 0);
        $(".ImageAndTitleView, .dvToolItem").attr("ClickedImageTitle", "false");
        $(".ImageAndTitleView, .dvToolItem").css("z-index", 0);
        tl.play();
        $("#scrollSpacer").css("height", "0px");
    }

    var toggleFeatured = function (ctrl) {
        if (ctrl.attr("on") == "true") {
            $("#featuredFilter").val("");
            ctrl.attr("on", "false");
            ctrl.find('.dvSelIndicatorFeatured').animate({ width: "0px", right: "0px" }, _tagAnimationSpeed);
            ctrl.find(".dvApplyClearFeatured").css("display", "none");
        } else {
            $("#featuredFilter").val("1");
            $('.dvSelIndicatorFeatured').animate({ width: "0px", right: "0px" }, 200);
            ctrl.attr("on", "true");
            ctrl.find('.dvSelIndicatorFeatured').animate({ width: "10px", right: "-10px" }, _tagAnimationSpeed);
            ctrl.find(".dvApplyClearFeatured").css("display", "block");
        }
    }

    //Keep the filter and category selection separate
    var toggleCategory = function (ctrl) {
        if (ctrl.attr("on") == "true") {
            $("#catFilter").val("");
            ctrl.attr("on", "false");
            ctrl.find('.dvSelIndicatorCat').animate({ width: "0px", right: "15px" }, _tagAnimationSpeed);
            ctrl.find(".dvApplyClearCat").css("display", "none");
        } else {
            $("#catFilter").val(ctrl.attr('catid'));
            $('.dvSelIndicatorCat').animate({ width: "0px", right: "15px" }, 200);
            $("#toolsCategoriesControl .category").attr("on", "false");
            ctrl.attr("on", "true");
            ctrl.find('.dvSelIndicatorCat').animate({ width: "10px", right: "5px" }, _tagAnimationSpeed);
            ctrl.find(".dvApplyClearCat").css("display", "block");
        }
    };

    //Keep the filter and category selection separate
    var toggleFilter = function (ctrl) {
        if (ctrl.attr("on") == "true") {
            $("#typeFilter").val("");
            ctrl.attr("on", "false");
            ctrl.find('.dvSelIndicatorType').animate({ width: "0px", right: "15px" }, _tagAnimationSpeed);
            ctrl.find(".dvApplyClearType").css("display", "none");
        } else {
            $("#typeFilter").val(ctrl.attr('tabid'));
            $('.dvSelIndicatorType').animate({ width: "0px", right: "15px" }, 200);
            $("#toolsFilterControls .category").attr("on", "false");
            ctrl.attr("on", "true");
            ctrl.find('.dvSelIndicatorType').animate({ width: "10px", right: "5px" }, _tagAnimationSpeed);
            ctrl.find(".dvApplyClearType").css("display", "block");
        }
    };

    // reloads the results page based on the values of the search form, including the two hidden  fields for activity category id and tags
    var loadResults = function (query, sf) {
        var href = $("#clearLink").attr("href");
        var first = "?";
        var amp = "";
        if ($('#catFilter').val() != '') {
            href = href + first + amp + "catFilter=" + $('#catFilter').val();
            first = ""; amp = "&";
        }
        if ($('#typeFilter').val() != '') {
            href = href + first + amp + "typeFilter=" + $('#typeFilter').val();
            first = ""; amp = "&";
        }

        if (query.val() != '' && query.val() != defaultSearchValue) {
            href = href + first + amp + "searchText=" + query.val();
            first = ""; amp = "&";
        }

        if (getParameterByName("useNewTagging") != "") {            
            href = href + first + amp + "useNewTagging=1";
            first = ""; amp = "&";
        }

        href = href + first + amp + "page=1";
        first = ""; amp = "&";

        if (sf.val() == 'FEATURED' || $('#featuredFilter').val() == 1) {
            href = href + first + amp + "searchType=1";
        }
        $("#reloadLink").attr("href", href);
        $("#reloadLink").click();
    };


    function getParameterByName(name) {
        name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)", "i"),
            results = regex.exec(location.search);
        return results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    }

    return {
        init: init,
        initRepeater: initRepeater
    };
})();